import React, { useCallback, useEffect, useMemo, useState } from "react";
import Close from "@mui/icons-material/Close";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import PlayArrow from "@mui/icons-material/PlayArrow";
import Style from "@mui/icons-material/Style";
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  Fade,
  Modal,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  OutlinedInput,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  CircularProgress,
  InputAdornment,
  DialogContentText,
  Checkbox,
  ListItemText,
  Grid,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  DataGrid,
  getGridStringOperators,
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import InfoIcon from "@mui/icons-material/Info";
import Backdrop from "@mui/material/Backdrop";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import {
  getDid,
  createDestination,
  updateDestination,
  updateAssignment,
  getAdminRedirectGroups,
  suspendDestination,
} from "../../redux/actions/destinationAction";
import { getExtension } from "../../redux/actions/extensionAction";
import { getAllUsers } from "../../redux/actions/userAction";
import { makeStyles } from "@mui/styles";
import { api } from "../../mockData";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  getAdminResellersList,
  getAdminUsersList,
} from "../../redux/actions/adminPortal_listAction";
import dayjs from "dayjs";
import { StyledDataGrid } from "../../pages/CustomDataGrid";
import { GET_DID_SUCCESS } from "../../redux/constants/destinationConstants";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";
import HowToRegIcon from "@mui/icons-material/HowToReg"; // For Un-Suspend
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers";
import { getAdminDidCarrier } from "../../redux/actions/adminPortal/adminPortal_rolesAction";
import PageTitle from "../common/PageTitle";

const drawerWidth = 240;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  // backgroundColor: "rgb(9, 56, 134)",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const useStyles = makeStyles({
  borderedGreen: {
    borderLeft: "3px solid green", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  borderedRed: {
    borderLeft: "3px solid red", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
});

const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-row": {
            minHeight: "auto", // Adjust row height to make it more compact
          },
        },
      },
      defaultProps: {
        density: "compact", // Set default density to compact
      },
    },
  },
});
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
// const names = ["Redirect", "Manage", "Sip"];
const names = ["Manage"];
const sub_type = ["Extension", "Queue"];

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{
        "& .MuiButton-root": {
          fontSize: {
            xs: "12px", // mobile
            sm: "14px", // tablet
            md: "14px", // desktop
          },
          minWidth: "auto",
        },
        "& .MuiSvgIcon-root": {
          fontSize: {
            xs: "16px",
            sm: "18px",
          },
        },
      }}
    >
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

function MultiValueInput(props) {
  const { item, applyValue, focusElementRef } = props;

  const handleChange = (e) => {
    const raw = e.target.value;

    const values = raw
      .split(/[\s,]+/) // space, comma, newline
      .map((v) => v.trim())
      .filter(Boolean);

    applyValue({ ...item, value: values });
  };

  const handleClear = () => {
    applyValue({ ...item, value: [] });
  };

  return (
    <TextField
      inputRef={focusElementRef}
      className="multiValueFilterInput"
      value={Array.isArray(item.value) ? item.value.join(", ") : ""}
      onChange={handleChange}
      placeholder="Enter numbers separated by space or comma"
      variant="standard"
      fullWidth
      InputProps={{
        endAdornment: item?.value?.length ? (
          <InputAdornment position="end">
            <IconButton
              edge="end"
              size="small"
              onClick={handleClear}
              sx={{
                color: "#9CA3AF",
                "&:hover": { color: "#DC2626" },
              }}
            >
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
}

function DID_TFN_number({ colorThem }) {
  const state = useSelector((state) => state);
  const token = JSON.parse(localStorage.getItem("admin"));
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("admin"));
  const [selectedValue, setSelectedValue] = useState("A");
  const ivrOptions = [
    "no",
    "random",
    ...Array.from({ length: 100 }, (_, i) => i),
  ];
  const options = ["VOIP", "FAKE"];
  const [ivrAuthentication, setIvrAuthentication] = useState([]);
  const [suspendValue, setSuspendValue] = useState(0);
  const [subType, setSubType] = useState("");
  const [didId, setDidId] = useState("");
  const [destinationDescription, setDestinationDescription] = useState("");
  const [destinationAction, setDestinationAction] = useState([]);
  const [openimport, setOpenImport] = React.useState(false);
  const [file, setFile] = useState();
  const [userId, setUserId] = useState(null);
  const [redirectGroup, setRedirectGroup] = useState("");
  const [redirectGroupData, setRedirectGroupData] = useState([]);
  const [userUuid, setUserUuid] = useState("");
  const [open, setOpen] = React.useState(false);
  const [response, setResponse] = useState("");
  const [edit, setEdit] = useState(false);
  const [tfnNumber, setTfnNumber] = useState("");
  const [didNumber, setDidNumber] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openD, setOpenD] = useState(false);
  const [radioValue, setRadioValue] = useState("A");
  const [clientName, setClientName] = useState("");
  const [maxCall, setMaxCall] = useState("");
  const [recording, setRecording] = useState(true);
  const [resellerUsersData, setResellerUsersData] = useState([]);
  const [extensionNumber, setExtensionNumber] = useState([]);
  const [queueName, setQueueName] = useState("");
  const [queue, setQueue] = useState([]);
  const [carrierName, setCarrierName] = useState("");
  const [resellerId, setResellerId] = useState("");
  const [resellerUsers, setResellerUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [voip, setVoip] = useState([]);
  const [resellers, setResellers] = useState([]);
  const [loader, setLoader] = useState(true);
  const [searchDestination, setSearchDestination] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [validation, setValidation] = useState({
    tfnNumber: "",
    userId: "",
    serviceType: "",
    recording: "",
    selectedValue: "",
    carrierName: "",
  });
  const [alertMessage, setAlertMessage] = useState(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  useMemo(() => {
    setRedirectGroupData(state.getRedirectGroup.redirectGroup);
  }, [state.getRedirectGroup.redirectGroup]);

  const handleOpen = () => setOpen(true);
  const classes = useStyles();

  const handleClick = () => {
    window.open("/file/upload_destination_number.csv", "_blank");
  };

  const handleFromDateChange = (newValue) => {
    setFromDate(newValue);
    console.log("Selected:", newValue?.format("YYYY-MM-DD"));
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedValue("A");
    setTfnNumber("");
    setClientName("");
    setMaxCall("");
    setDestinationAction([]);
    setUserUuid("");
    setDestinationDescription("");
    // Default Recording to Yes for every Add — requested 2026-04-24.
    setRecording(true);
    setExtensionNumber([]);
    setQueue([]);
    setQueueName("");
    setSubType("");
    setUserId("");
    setCarrierName("");
    setValidation({
      tfnNumber: "",
      userId: "",
      serviceType: "",
      recording: "",
      selectedValue: "",
      carrierName: "",
    });
    setResellerId("");
    setRedirectGroupData([]);
    setRedirectGroup("");
    setDidNumber([]);
    setFromDate(null);
    setVoip([]);
  };

  const handleSelectionChange = (selection) => {
    setSelectedRows(selection);
  };

  const handleEditOpen = () => setEdit(true);

  const handleEditClose = () => {
    setEdit(false);
    setSelectedValue("A");
    setTfnNumber("");
    setClientName("");
    setMaxCall("");
    setDestinationAction([]);
    setDestinationDescription("");
    // Default Recording to Yes so the next Add starts with it enabled.
    setRecording(true);
    setQueue([]);
    setQueueName("");
    setSubType("");
    setUserId("");
    setSuspendValue("");
    setCarrierName("");
    setValidation({
      tfnNumber: "",
      userId: "",
      serviceType: "",
      recording: "",
      selectedValue: "",
      carrierName: "",
    });
    setResellerId("");
    setRedirectGroupData([]);
    setRedirectGroup("");
    setIvrAuthentication("");
    setFromDate(null);
    setVoip([]);
  };

  const handleAlertClose = () => {
    setAlertMessage(false);
  };

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const validateTfnNumber = (value) => {
    if (!value?.trim()) {
      return {
        valid: false,
        message: "Destination number is required",
      };
    }

    if (!/^\d{11}$/.test(value)) {
      return {
        valid: false,
        message: "Destination number must be exactly 11 digits",
      };
    }

    return { valid: true, message: "" };
  };

  const checkValidation = useCallback(() => {
    let errors = {};
    let isValid = true;

    // TFN validation
    const tfnValidation = validateTfnNumber(tfnNumber);
    if (!tfnValidation.valid) {
      errors.tfnNumber = tfnValidation.message;
      isValid = false;
    }

    // Carrier validation
    if (!carrierName?.trim()) {
      errors.carrierName = "Carrier name is required";
      isValid = false;
    }

    setValidation(errors);
    return isValid;
  }, [tfnNumber, carrierName]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = checkValidation();
    if (isValid) {
      let data = JSON.stringify({
        user_id: userId,
        reseller_id: resellerId,
        didnumber: tfnNumber,
        description: destinationDescription,
        did_status: selectedValue === "A" ? "A" : "D",
        recording: recording,
        redirect_group_id: redirectGroup,
        carrier_name: carrierName,
        voip_spam: voip,
        did_expiry_date:
          fromDate === null ? null : fromDate?.format("YYYY-MM-DD"),
      });
      dispatch(createDestination(data, handleClose, setResponse));
    }
  };

  const handleUpdateAssignment = useCallback((data) => {
    //  if(data.user_id !== null){
    let form = JSON.stringify({
      id: data.did_id,
      user_id: "None",
    });
    dispatch(updateAssignment(form, setResponse));

    // }
  }, []);

  const handleEdit = (data) => {
    handleEditOpen();
    setTfnNumber(data?.tfn_number);
    setSuspendValue(data?.is_suspended);
    setClientName(data?.user_uuid);
    setMaxCall(data?.max_call);
    setRedirectGroup(data?.redirect_group_id);
    setIvrAuthentication(data?.ivr_authendication);
    setDestinationAction(data?.details);
    setCarrierName(data?.carrier_name);
    setDestinationDescription(data?.description);
    setDidId(data?.did_id);
    setUserId(data?.user_id);
    setVoip(data?.voip_spam ? data?.voip_spam.split(",") : []);
    setRecording(String(data?.recording) === "true" ? true : false);
    setSelectedValue(
      data?.did_status === "A" ? "A" : data?.did_status === "D" ? "D" : "S",
    );
    setResellerId(data?.reseller_id === null ? "" : data?.reseller_id);
    setFromDate(
      data?.did_expiry_date === null ? null : dayjs(data?.did_expiry_date),
    );
  };

  useEffect(() => {
    // Check if userId is empty and reset redirectGroup, recording, and selectedValue
    if (userId === "") {
      setRedirectGroup("");
      setRecording(true);
      // Status MenuItems in this dialog are "A"/"D" (admin convention).
      // The previous value "t" was copy-pasted from the reseller version,
      // where MenuItems are "t"/"f" — in admin that leaves the Select
      // showing empty because no option matches.
      setSelectedValue("A");
    }
  }, [userId]);

  const handleUpdate = (e) => {
    e.preventDefault();
    const isValid = checkValidation();
    if (isValid) {
      let data = JSON.stringify({
        description: destinationDescription,
        did_status:
          selectedValue === "A" ? "A" : selectedValue === "D" ? "D" : "S",
        id: didId,
        user_id: userId,
        recording: recording,
        carrier_name: carrierName,
        reseller_id: resellerId,
        didnumber: tfnNumber,
        redirect_group_id: redirectGroup,
        ivr_options: ivrAuthentication,
        is_suspended: suspendValue,
        voip_spam: voip,
        did_expiry_date:
          fromDate === null ? null : fromDate?.format("YYYY-MM-DD"),
      });

      dispatch(updateDestination(data, setResponse, handleEditClose));
    }
  };

  const handleMessage = useCallback(
    (data) => {
      // setName(data?.buyer_name);
      // setId(data?.buyer_id);
      setAlertMessage(true);
    },
    [setName],
  );

  // ======import-start
  const handleOpenImport = () => setOpenImport(true);
  const handleCloseImport = () => setOpenImport(false);
  // =======import-end

  const handleOnChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      const token = JSON.parse(localStorage.getItem("admin"));
      try {
        const response = await axios.post(
          `${api.dev}/api/import_did_from_csv`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token.access_token} `,
            },
          },
        );
        if (response.data.status === 200) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
          setResponse(response);
          handleCloseImport();
        } else {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
        }
      } catch (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          toast.error(
            `Error: ${error.response.status} - ${error.response.data.message}`,
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1500,
            },
          );
        } else if (error.request) {
          // The request was made but no response was received
          toast.error("No response from server. Please try again later.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          toast.error("An error occurred while setting up the request.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
        }
      }
    } else {
      toast.warn("Please select a file to upload.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      });
    }
  };

  useEffect(() => {
    dispatch(getDid(radioValue, setLoader));
    dispatch({
      type: GET_DID_SUCCESS,
      payload: [],
    });
    dispatch(getAdminDidCarrier());
  }, [radioValue, response]);
  useEffect(() => {
    dispatch(getAdminRedirectGroups(userId));
  }, [userId]);
  useEffect(() => {
    dispatch(getExtension(""));
    dispatch(getAllUsers(""));
    dispatch(getAdminUsersList());
    dispatch(getAdminResellersList());
  }, []);
  useEffect(() => {
    if (resellerId !== "None") {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${api.dev}/api/getreselleruserlist?reseller_id=${resellerId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token} `,
        },
      };
      axios
        .request(config)
        .then((response) => {
          setResellerUsersData(response?.data?.data);
        })
        .catch((error) => {});
    }
  }, [resellerId]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "tfnNumber":
        const trimmedValue = value.trim();
        setTfnNumber(trimmedValue);
        break;
      case "clientName":
        setClientName(value);
        break;
      case "maxCall":
        const maxCall = value.trim();
        setMaxCall(maxCall);
        break;
      case "status":
        setSelectedValue(value);
        break;

      default:
        break;
    }
  };

  const isRowBordered = (params) => {
    const { row } = params;

    // Add your condition here, for example, adding border to rows where age is greater than 25
    return row.status === true;
  };

  useMemo(() => {
    if (state?.getAdminUsersList?.userList) {
      const usersArray = Object.keys(state?.getAdminUsersList?.userList)?.map(
        (key) => ({
          user_id: key,
          username: state?.getAdminUsersList?.userList[key],
        }),
      );
      setUsers(usersArray);
    }
    if (state?.getAdminResellersList?.resellerList) {
      const resellerArray = Object.keys(
        state?.getAdminResellersList?.resellerList,
      )?.map((key) => ({
        reseller_id: key,
        username: state?.getAdminResellersList?.resellerList[key],
      }));
      setResellers(resellerArray);
    }

    if (resellerUsersData) {
      const usersArray = Object.keys(resellerUsersData)?.map((key) => ({
        user_id: key,
        username: resellerUsersData[key],
      }));
      setResellerUsers(usersArray);
    }
  }, [
    state?.getAdminUsersList?.userList,
    state?.getAdminResellersList?.resellerList,
    resellerUsersData,
  ]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const baseColumns = [
    {
      field: "action",
      headerName: "Edit",
      headerClassName: "custom-header",
      headerAlign: "start",
      align: "start",
      sortable: false,
      width: isXs ? 50 : 50,
      minWidth: 50,
      maxWidth: 50,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Edit
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            {user.user_role === "Reseller" ? (
              <></>
            ) : (
              <>
                <Tooltip title="Edit">
                  <IconButton onClick={() => handleEdit(params.row)}>
                    <Edit
                      index={params.row.id}
                      style={{
                        cursor: "pointer",
                        color: "#42765f",
                        fontSize: isMobile ? "20px" : "25x",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </div>
        );
      },
    },
    {
      field: "tfn_number",
      headerName: "Destination",
      headerClassName: "custom-header",
      width: isXs ? 110 : 120,
      minWidth: 110,
      maxWidth: 110,
      headerAlign: "start",
      align: "start",
      filterOperators: getGridStringOperators().map((operator) => {
        if (operator.value === "isAnyOf") {
          return {
            ...operator,
            InputComponent: MultiValueInput,
            getApplyFilterFn: (filterItem) => {
              if (
                !Array.isArray(filterItem.value) ||
                filterItem.value.length === 0
              ) {
                return null;
              }

              return (params) => {
                if (params.value == null) return false;

                return filterItem.value.includes(String(params.value));
              };
            },
          };
        }
        return operator;
      }),
    },
    {
      field: "username",
      headerName: "User Name",
      headerClassName: "custom-header",
      width: isXs ? 120 : 120,
      minWidth: 120,
      maxWidth: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          User Name
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              textTransform: "capitalize",
              fontSize: "calc(0.6rem + 0.2vw)",
            }}
          >
            {params.row.username}
          </span>
        );
      },
    },
    {
      field: "resellername",
      headerName: "Reseller",
      headerClassName: "custom-header",
      width: isXs ? 90 : 90,
      minWidth: 90,
      maxWidth: 90,
      headerAlign: "start",
      align: "start",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Reseller
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              textTransform: "capitalize",
              fontSize: "calc(0.6rem + 0.2vw)",
            }}
          >
            {params.row.resellername}
          </span>
        );
      },
    },
    {
      field: "redirect_group_name",
      headerName: "Campaign Name",
      headerClassName: "custom-header",
      width: isXs ? 90 : 120,
      minWidth: 90,
      maxWidth: 120,
      headerAlign: "start",
      align: "center",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          {isSmallScreen ? "Camp. Name" : "Campaign Name"}
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span style={{ fontSize: "calc(0.6rem + 0.2vw)" }}>
            {params.row.redirect_group_name}
          </span>
        );
      },
    },
    // {
    //   field: "total_call_duration",
    //   headerName: "Total Call Duration",
    //   headerClassName: "custom-header",
    //   width: 150,
    //   headerAlign: "center",
    //   align: "center",
    // },

    {
      field: "ivr_authendication",
      headerName: "IVR",
      headerClassName: "custom-header",
      width: isXs ? 50 : 60,
      minWidth: 50,
      maxWidth: 60,
      headerAlign: "start",
      align: "center",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          {isSmallScreen ? "IVR" : "IVR"}
        </Typography>
      ),

      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.3vw)" }} // Match header size or set your own
        >
          {params.value}
        </Typography>
      ),
      // renderCell: (params) => {
      //   return (
      //     <span style={{ textTransform: "capitalize" }}>
      //       {params.row.ivr_authendication === true ? "Yes" : "No"}
      //     </span>
      //   );
      // },
    },

    {
      field: "recording",
      headerName: "Recording",
      headerClassName: "custom-header",
      width: isXs ? 60 : 90,
      minWidth: 60,
      maxWidth: 90,
      headerAlign: "start",
      align: "start",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          {isSmallScreen ? "Recor." : "Recording"}
        </Typography>
      ),
      renderCell: (params) => {
        const isRecordingEnabled = params.row.recording === true;

        return (
          <div className="d-flex justify-content-between align-items-center">
            <div
              style={{
                color: isRecordingEnabled ? "green" : "red",
                padding: isMobile ? "5px" : "7px",
                borderRadius: "5px",
                textTransform: "capitalize",
                fontSize: "calc(0.6rem + 0.2vw)",
              }}
            >
              {isRecordingEnabled ? "Yes" : "No"}
            </div>
          </div>
        );
      },
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   headerClassName: "custom-header",
    //   width: isXs ? 70 : 80,
    //   minWidth: 70,
    //   maxWidth: 80,
    //   headerAlign: "start",
    //   align: "start",
    //   renderHeader: () => (
    //     <Typography
    //       variant="body2"
    //       sx={{
    //         fontSize: "calc(0.6rem + 0.2vw)",
    //         fontWeight: "bold",
    //         color: "white !important",
    //       }}
    //     >
    //       Status
    //     </Typography>
    //   ),
    //   renderCell: (params) => {
    //     const { status, is_suspended } = params.row;

    //     // Define the key as a string like "true_1", "false_0", etc.
    //     const key = `${String(status)}_${String(is_suspended)}`;

    //     // Lookup map
    //     const labelMap = {
    //       1: { label: "Suspend", color: "orange" }, // Suspend gets priority
    //       true_0: { label: "Active", color: "green" },
    //       false_1: { label: "Suspend", color: "orange" },
    //       false_0: { label: "Deactive", color: "red" },
    //     };

    //     // Fallback in case of unknown values
    //     const { label, color } = labelMap[key] || {
    //       label: "Suspand",
    //       color: "orange",
    //     };

    //     return (
    //       <div
    //         style={{
    //           color,
    //           padding: isMobile ? "5px" : "7px",
    //           borderRadius: "5px",
    //           textAlign: "center",
    //           fontSize: "calc(0.6rem + 0.2vw)",
    //         }}
    //       >
    //         {label}
    //       </div>
    //     );
    //   },
    // },

    {
      field: "description",
      headerName: "Description",
      headerClassName: "custom-header",
      width: isXs ? 70 : 90,
      minWidth: 70,
      maxWidth: 90,
      headerAlign: "start",
      align: "start",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Description
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              textTransform: "capitalize",
              fontSize: "calc(0.6rem + 0.2vw)",
            }}
          >
            {params.row.description}
          </span>
        );
      },
    },

    {
      field: "voip_spam",
      headerName: "Voip Spam",
      headerClassName: "custom-header",
      width: isXs ? 100 : 120,
      minWidth: 100,
      maxWidth: 120,
      headerAlign: "start",
      align: "start",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Voip Spam
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              textTransform: "capitalize",
              fontSize: "calc(0.6rem + 0.2vw)",
            }}
          >
            {params.row.voip_spam}
          </span>
        );
      },
    },
    {
      field: "carrier_name",
      headerName: "Carrier Name",
      headerClassName: "custom-header",
      width: isXs ? 100 : 150,
      minWidth: 100,
      maxWidth: 150,
      headerAlign: "start",
      align: "start",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Carrier Name
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              textTransform: "capitalize",
              fontSize: "calc(0.6rem + 0.2vw)",
            }}
          >
            {params.row.carrier_name}
          </span>
        );
      },
    },

    {
      field: "did_expiry_date",
      headerName: "Expiry Date",
      headerClassName: "custom-header",
      width: isXs ? 90 : 90,
      minWidth: 90,
      maxWidth: 90,
      headerAlign: "start",
      align: "start",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Expiry Date
        </Typography>
      ),
      renderCell: (params) => {
        const formattedDate =
          params.value !== null ? dayjs(params.value).format("DD/MM/YYYY") : "";

        return (
          <>
            {formattedDate && (
              <span>
                <Typography
                  style={{ color: "green", fontSize: "calc(0.6rem + 0.2vw)" }}
                >
                  {formattedDate}
                </Typography>
              </span>
            )}
          </>
        );
      },
    },

    {
      field: "created_at",
      headerName: "Created At",
      headerClassName: "custom-header",
      width: isXs ? 90 : 90,
      minWidth: 90,
      maxWidth: 90,
      headerAlign: "start",
      align: "start",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Created At
        </Typography>
      ),
      renderCell: (params) => {
        // Parse the date string and format it
        const dateTimeString = params.value; // e.g., "2024:10:11 12:41:56"
        const formattedString = dateTimeString
          ?.replace(/:/g, "-") // Change to "2024-10-11 12-41-56"
          ?.replace(/-(\d{2})-(\d{2})$/, ":$1:$2"); // Change to "2024-10-11 12:41:56"
        const formattedDate = dayjs(formattedString).format("DD/MM/YYYY");
        const formattedTime = dayjs(formattedString).format("HH:mm:ss");

        return (
          <span>
            <Typography
              style={{ color: "green", fontSize: "calc(0.6rem + 0.2vw)" }}
            >
              {formattedDate}
            </Typography>{" "}
            <Typography
              style={{ color: "blue", fontSize: "calc(0.6rem + 0.2vw)" }}
            >
              {formattedTime}
            </Typography>
          </span>
        );
      },
    },

    {
      field: "updated_at",
      headerName: "Update Date",
      align: "center",
      flex: 1,
      minWidth: 90,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Update Date
        </Typography>
      ),
      headerClassName: "custom-header",
      renderCell: (params) => {
        // Parse the date string and format it
        const dateTimeString = params?.value; // e.g., "2024:10:11 12:41:56"
        const formattedString = dateTimeString
          ?.replace(/:/g, "-") // Change to "2024-10-11 12-41-56"
          ?.replace(/-(\d{2})-(\d{2})$/, ":$1:$2"); // Change to "2024-10-11 12:41:56"
        const formattedDate = dayjs(formattedString).format("DD/MM/YYYY");
        const formattedTime = dayjs(formattedString).format("HH:mm:ss");

        return (
          <span>
            <Typography
              style={{ color: "brown", fontSize: "calc(0.6rem + 0.2vw)" }}
            >
              {formattedDate}
            </Typography>{" "}
            <Typography
              style={{ color: "blue", fontSize: "calc(0.6rem + 0.2vw)" }}
            >
              {formattedTime}
            </Typography>
          </span>
        );
      },
    },
  ];

  const statusColumn = {
    field: "did_status",
    headerName: "Status",
    headerClassName: "custom-header",
    width: isXs ? 70 : 80,
    minWidth: 70,
    maxWidth: 80,
    headerAlign: "start",
    align: "start",
    renderHeader: () => (
      <Typography
        variant="body2"
        sx={{
          fontSize: "calc(0.6rem + 0.2vw)",
          fontWeight: "bold",
          color: "white !important",
        }}
      >
        Status
      </Typography>
    ),
    // renderCell: (params) => {
    //   const { status, is_suspended } = params.row;

    //   // Define the key as a string like "true_1", "false_0", etc.
    //   const key = `${String(status)}_${String(is_suspended)}`;

    //   // Lookup map
    //   const labelMap = {
    //     1: { label: "Suspend", color: "orange" }, // Suspend gets priority
    //     true_0: { label: "Active", color: "green" },
    //     false_1: { label: "Suspend", color: "orange" },
    //     false_0: { label: "Deactive", color: "red" },
    //   };

    //   // Fallback in case of unknown values
    //   const { label, color } = labelMap[key] || {
    //     label: "Suspand",
    //     color: "orange",
    //   };

    //   return (
    //     <div
    //       style={{
    //         color,
    //         padding: isMobile ? "5px" : "7px",
    //         borderRadius: "5px",
    //         textAlign: "center",
    //         fontSize: "calc(0.6rem + 0.2vw)",
    //       }}
    //     >
    //       {label}
    //     </div>
    //   );
    // },
    renderCell: (params) => {
      const status = params.row.did_status;
      return (
        <>
          <Typography
            style={{
              color:
                status === "A" ? "green" : status === "S" ? "orange" : "red",
              padding: isMobile ? "5px" : "7px",
              borderRadius: "5px",
              textAlign: "center",
              fontSize: "calc(0.6rem + 0.2vw)",
            }}
          >
            {status === "A"
              ? "Active"
              : status === "S"
                ? "Suspended"
                : "Deactive"}
          </Typography>
        </>
      );
    },
  };

  const columns = useMemo(() => {
    if (radioValue === "") {
      // Sirf "All" par status column add karo
      return [...baseColumns, statusColumn];
    }

    if (radioValue === "s") {
      // Sirf "All" par status column add karo
      return [...baseColumns];
    }
    return baseColumns; // baaki sab par status hide
  }, [radioValue, baseColumns]);

  const rows = useMemo(() => {
    const calculatedRows = [];
    state?.allDid?.alldid &&
      state?.allDid?.alldid?.forEach((item, index) => {
        calculatedRows.push({
          id: index + 1,
          did_id: item?.id,
          tfn_number: item?.didnumber,
          username: item?.username,
          record: item?.destination_record,
          created_at: item?.created_at,
          updated_at: item?.updated_at,
          extension: item?.destination_actions,
          did_status: item?.did_status,
          description: item?.description,
          recording: item.recording,
          user_id: item.user_id,
          reseller_id: item.reseller_id,
          reseller_name: item.reseller_name,
          carrier_name: item.carrier_name,
          total_call_duration: item.total_call_duration,
          Assignment: item.Assignment,
          redirect_group_id: item.redirect_group_id,
          resellername: item.resellername,
          group_name: item.group_name,
          ivr_authendication: item.ivr_options,
          redirect_group_name: item.redirect_group_name,
          is_suspended: item.is_suspended,
          did_expiry_date: item.did_expiry_date,
          voip_spam: item.voip_spam,
        });
      });
    return calculatedRows;
  }, [state?.allDid?.alldid]);

  const filteredRows = rows.filter((row) =>
    row.tfn_number?.toLowerCase().includes(searchDestination.toLowerCase()),
  );

  const selectedCallerDataSet = new Set(); // Using Set to avoid duplicates

  selectedRows.forEach((id) => {
    const selectedRow = filteredRows.find((row) => row.id === id);
    if (selectedRow) {
      selectedCallerDataSet.add(selectedRow.did_id); // Add only did_id
    }
  });

  const selectedCallerData = Array.from(selectedCallerDataSet); // Convert to comma-separated string

  const handleDelete = useCallback(() => {
    let isSuspendedStatus = ""; // default suspend

    // Find the first selected row's suspension status
    const firstSelectedRow = filteredRows.find(
      (row) => row.id === selectedRows[0],
    );
    if (firstSelectedRow) {
      isSuspendedStatus = firstSelectedRow.did_status === "A" ? "S" : "A";
    }
    const selectedCallerDataSet = new Set();

    selectedRows.forEach((id) => {
      const selectedRow = filteredRows.find((row) => row.id === id);
      if (selectedRow) {
        selectedCallerDataSet.add(selectedRow.did_id);
      }
    });

    const selectedCallerData = Array.from(selectedCallerDataSet);

    dispatch(
      suspendDestination(
        JSON.stringify({
          ids: selectedCallerData,
          did_status: firstSelectedRow?.did_status === "A" ? "S" : "A",
        }),
        setResponse,
      ),
    );

    setAlertMessage(false);
    setSelectedRows([]);
  }, [dispatch, setResponse, setSelectedRows, selectedRows, filteredRows]);

  const getToggleSuspendText = () => {
    const firstSelectedRow = filteredRows.find(
      (row) => row.id === selectedRows[0],
    );
    if (firstSelectedRow?.did_status === "S") return "Un-Suspend";
    return "Suspend";
  };

  const getSuspendIcon = () => {
    const firstSelectedRow = filteredRows.find(
      (row) => row.id === selectedRows[0],
    );
    return firstSelectedRow?.did_status === "S" ? (
      <HowToRegIcon />
    ) : (
      <NoAccountsIcon />
    );
  };

  const filteredDid = state?.allDid?.alldid?.filter((item) =>
    item.didnumber.toString().includes(searchTerm),
  );

  return (
    <>
      <div className={`App ${colorThem} `}>
        <div className="contant_box">
          <Box
            className="right_sidebox mobile_top_pddng"
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="">
                    {/* <!----> */}
                    <div className="tab-content" id="pills-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        {/* <!--role-contet--> */}
                        <div className="">
                          <div
                            className="cntnt_title"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "end",
                            }}
                          >
                            <div>
                              <PageTitle title="Destination" />
                              {/* <p>
                                Inbound destinations are the DID/DDI, DNIS or
                                Alias for inbound calls.
                              </p> */}
                            </div>
                            <div className="d-xxl-block d-xl-block d-lg-block d-md-block d-sm-none d-none">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  position: "relative",
                                  top: "0",
                                  right: "-15px",
                                }}
                              >
                                {/* import */}
                                {user.user_role === "Reseller" ? (
                                  <></>
                                ) : (
                                  <>
                                    <Typography
                                      onClick={handleClick}
                                      target="_blank"
                                      className="hover-content"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <IconButton>
                                        <FileDownloadIcon />
                                      </IconButton>
                                    </Typography>

                                    <div
                                      className="n-ppost"
                                      style={{ paddingRight: "20px" }}
                                    >
                                      Sample
                                    </div>
                                    <img
                                      className="n-ppost-name"
                                      src="https://i.ibb.co/rMkhnrd/sample2.png"
                                      alt="Image"
                                    />

                                    <div>
                                      <IconButton
                                        className="all_button_clr"
                                        onClick={handleOpenImport}
                                        sx={{
                                          fontSize: "15px",
                                          borderRadius: "5px",
                                          border: "none",
                                          color: "#fff",
                                          px: 4,
                                          textTransform: "capitalize",
                                          height: "35px",
                                          width: "90px",
                                          minWidth: "90px",
                                          flexShrink: 0,
                                          display: "inline-flex",
                                          justifyContent: "space-evenly",
                                          alignItems: "center",
                                        }}
                                      >
                                        Import <ImportExportIcon />
                                      </IconButton>
                                    </div>
                                  </>
                                )}

                                <Modal
                                  open={openimport}
                                  onClose={handleCloseImport}
                                  aria-labelledby="modal-modal-title"
                                  aria-describedby="modal-modal-description"
                                >
                                  <Fade
                                    in={openimport}
                                    className="bg_imagess"
                                    style={{ padding: "5px 0px" }}
                                  >
                                    <Box
                                      sx={style}
                                      borderRadius={"10px"}
                                      textAlign={"center"}
                                    >
                                      <IconButton
                                        onClick={handleCloseImport}
                                        sx={{ float: "inline-end" }}
                                      >
                                        <Close />
                                      </IconButton>

                                      <form
                                        style={{
                                          textAlign: "center",
                                          height: "auto",
                                          overflow: "auto",
                                          paddingTop: "10px",
                                          padding: "20px",
                                        }}
                                      >
                                        <Typography
                                          id="transition-modal-title"
                                          variant="h6"
                                          component="h2"
                                          color={"#092b5f"}
                                          fontSize={"18px"}
                                          fontWeight={"600"}
                                        >
                                          Import File
                                        </Typography>

                                        <br />
                                        <input
                                          style={{
                                            //width: "100%",
                                            margin: "7px 0",
                                            textAlign: "center !important",
                                          }}
                                          type={"file"}
                                          // id={"csvFileInput"}
                                          // accept={".csv"}
                                          onChange={handleOnChange}
                                        />
                                        <br />
                                        <br />

                                        <Button
                                          variant="contained"
                                          className="all_button_clr"
                                          color="primary"
                                          sx={{
                                            fontSize: "16px !impotant",
                                            background:
                                              "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                            marginTop: "0px",
                                            padding: "10px 20px !important",
                                            textTransform:
                                              "capitalize !important",
                                          }}
                                          onClick={handleCloseImport}
                                        >
                                          Cancel
                                        </Button>
                                        <Button
                                          variant="contained"
                                          className="all_button_clr"
                                          color="primary"
                                          sx={{
                                            fontSize: "16px !impotant",
                                            background: "#092b5f",
                                            marginTop: "0px",
                                            padding: "10px 20px !important",
                                            textTransform:
                                              "capitalize !important",
                                          }}
                                          //onClick={handleSubmit}
                                          onClick={(e) => {
                                            handleOnSubmit(e);
                                          }}
                                        >
                                          Submit
                                        </Button>
                                      </form>
                                    </Box>
                                  </Fade>
                                </Modal>
                                {/* import-end */}

                                {/* ==Add-modal== */}

                                {user.user_role === "Reseller" ? (
                                  <></>
                                ) : (
                                  <>
                                    {" "}
                                    <div>
                                      <IconButton
                                        className="all_button_clr"
                                        onClick={handleOpen}
                                        sx={{
                                          fontSize: "15px",
                                          borderRadius: "5px",
                                          border: "none",
                                          color: "#fff",
                                          px: 4,
                                          textTransform: "capitalize",
                                          height: "35px",
                                          width: "90px",
                                          minWidth: "90px",
                                          flexShrink: 0,
                                          display: "inline-flex",
                                          justifyContent: "space-evenly",
                                          alignItems: "center",
                                        }}
                                      >
                                        Add <AddOutlinedIcon />
                                      </IconButton>
                                    </div>
                                  </>
                                )}

                                {/* -----   Add Campaigns Modal Start   ----- */}

                                <Dialog
                                  className="custom_dailog_box_user"
                                  open={open}
                                  onClose={handleClose}
                                  sx={{ textAlign: "center" }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      paddingTop: "10px",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Typography
                                      className="modal_heading"
                                      sx={{
                                        color: "#133325",
                                        fontWeight: "600",
                                        width: "500px",
                                      }}
                                    >
                                      Add DID
                                    </Typography>
                                    <IconButton
                                      className="close_icon"
                                      onClick={handleClose}
                                      sx={{ float: "inline-end" }}
                                    >
                                      <Close />
                                    </IconButton>
                                  </Box>
                                  <DialogContent>
                                    <form>
                                      <form
                                        style={{
                                          textAlign: "center",

                                          // overflow: "auto",
                                          paddingTop: "10px",
                                          padding: "0px 10px;",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                          <Grid item xs={12} md={6}>
                                            <TextField
                                              style={{
                                                width: "100%",
                                              }}
                                              type="text"
                                              label="DID Number"
                                              variant="outlined"
                                              name="tfnNumber"
                                              value={tfnNumber}
                                              onChange={(e) => {
                                                const numericValue =
                                                  e.target.value.replace(
                                                    /[^0-9]/g,
                                                    "",
                                                  );
                                                setTfnNumber(numericValue);
                                              }}
                                              inputProps={{
                                                inputMode: "numeric",
                                                // pattern: '[0-9]*',
                                              }}
                                            />

                                            {validation.tfnNumber && (
                                              <p
                                                className="mb-0"
                                                style={{
                                                  color: "red",
                                                  textAlign: "left",
                                                }}
                                              >
                                                {validation.tfnNumber}
                                              </p>
                                            )}
                                          </Grid>
                                          <Grid item xs={12} md={6}>
                                            <FormControl
                                              fullWidth
                                              style={{
                                                width: "100%",
                                              }}
                                              className={classes.formControl}
                                            >
                                              <InputLabel id="demo-simple-select-label">
                                                Reseller
                                              </InputLabel>

                                              <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Reseller"
                                                helperText="Select the language."
                                                style={{ textAlign: "left" }}
                                                value={resellerId}
                                                onChange={(e) => {
                                                  setResellerId(e.target.value);
                                                }}
                                                required
                                              >
                                                <MenuItem value={""}>
                                                  none
                                                </MenuItem>
                                                {resellers?.map(
                                                  (item, index) => {
                                                    return (
                                                      <MenuItem
                                                        key={index}
                                                        value={
                                                          item?.reseller_id
                                                        }
                                                      >
                                                        {item.username}
                                                      </MenuItem>
                                                    );
                                                  },
                                                )}
                                              </Select>
                                            </FormControl>
                                          </Grid>

                                          <Grid item xs={12} md={12}>
                                            {resellerId === "" ? (
                                              <>
                                                <FormControl
                                                  fullWidth
                                                  style={{
                                                    width: "100%",
                                                  }}
                                                >
                                                  <InputLabel id="demo-simple-select-label">
                                                    UserName
                                                  </InputLabel>

                                                  <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="UserName"
                                                    helperText="Select the language."
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                    value={userId}
                                                    onChange={(e) => {
                                                      setUserId(e.target.value);
                                                    }}
                                                  >
                                                    <MenuItem value={""}>
                                                      none
                                                    </MenuItem>
                                                    {users?.map(
                                                      (item, index) => {
                                                        return (
                                                          <MenuItem
                                                            key={index}
                                                            value={
                                                              item?.user_id
                                                            }
                                                          >
                                                            {item.username}
                                                          </MenuItem>
                                                        );
                                                      },
                                                    )}
                                                  </Select>
                                                </FormControl>
                                                {validation.userId && (
                                                  <p
                                                    className="mb-0"
                                                    style={{
                                                      color: "red",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {validation.userId}
                                                  </p>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                <FormControl
                                                  fullWidth
                                                  style={{
                                                    width: "100%",
                                                  }}
                                                >
                                                  <InputLabel id="demo-simple-select-label">
                                                    UserName
                                                  </InputLabel>

                                                  <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="UserName"
                                                    helperText="Select the language."
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                    value={userId}
                                                    onChange={(e) => {
                                                      setUserId(e.target.value);
                                                    }}
                                                  >
                                                    <MenuItem value={""}>
                                                      none
                                                    </MenuItem>
                                                    {resellerUsers?.map(
                                                      (item, index) => {
                                                        return (
                                                          <MenuItem
                                                            key={index}
                                                            value={
                                                              item?.user_id
                                                            }
                                                          >
                                                            {item.username}
                                                          </MenuItem>
                                                        );
                                                      },
                                                    )}
                                                  </Select>
                                                </FormControl>
                                                {validation.userId && (
                                                  <p
                                                    className="mb-0"
                                                    style={{
                                                      color: "red",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {validation.userId}
                                                  </p>
                                                )}
                                              </>
                                            )}
                                          </Grid>

                                          <Grid item xs={12} md={12}>
                                            <LocalizationProvider
                                              dateAdapter={AdapterDayjs}
                                              style={{
                                                width: "100%",
                                              }}
                                            >
                                              <DatePicker
                                                label="Expiry Date"
                                                value={fromDate}
                                                onChange={(newValue) => {
                                                  handleFromDateChange(
                                                    newValue,
                                                  );
                                                }}
                                                format="DD/MM/YYYY"
                                                closeOnSelect={true}
                                                slotProps={{
                                                  /* POPUP HEIGHT CONTROL */
                                                  desktopPaper: {
                                                    sx: {
                                                      height: "320px",
                                                      maxHeight: "320px",
                                                      overflow: "hidden",
                                                    },
                                                  },

                                                  /* CALENDAR INNER HEIGHT */
                                                  layout: {
                                                    sx: {
                                                      height: "300px",
                                                      ".MuiPickersLayout-contentWrapper":
                                                        {
                                                          height: "280px",
                                                        },
                                                    },
                                                  },

                                                  /* ACTION BUTTONS */
                                                  actionBar: {
                                                    actions: [
                                                      "clear",
                                                      "cancel",
                                                      "accept",
                                                    ],
                                                    sx: {
                                                      px: 1,
                                                      pb: 1,
                                                      pt: 0,
                                                      justifyContent:
                                                        "flex-end",
                                                      gap: "8px",
                                                    },
                                                  },

                                                  /* INPUT FIELD */
                                                  textField: {
                                                    fullWidth: true,
                                                    className: "frm_date",
                                                    InputProps: {
                                                      startAdornment: (
                                                        <InputAdornment position="start">
                                                          {/* icon */}
                                                        </InputAdornment>
                                                      ),
                                                    },
                                                  },
                                                }}
                                              />
                                            </LocalizationProvider>

                                            <InputLabel
                                              style={{
                                                textAlign: "left",
                                                fontSize: "11px",
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <b>Note:</b> &nbsp; A daily reset
                                              at 11:00 AM{" "}
                                            </InputLabel>
                                          </Grid>

                                          <Grid item xs={12} md={6}>
                                            <FormControl
                                              style={{
                                                width: "100%",
                                              }}
                                            >
                                              <InputLabel id="demo-multiple-checkbox-label">
                                                Campaign Name
                                              </InputLabel>
                                              <Select
                                                style={{ textAlign: "left" }}
                                                labelId="demo-multiple-checkbox-label"
                                                label="Campaign Name"
                                                id="demo-multiple-checkbox"
                                                fullWidth
                                                value={redirectGroup}
                                                onChange={(e) =>
                                                  setRedirectGroup(
                                                    e.target.value,
                                                  )
                                                }
                                                input={
                                                  <OutlinedInput label=" Campaign Name" />
                                                }
                                                MenuProps={MenuProps}
                                              >
                                                {redirectGroupData &&
                                                  redirectGroupData?.map(
                                                    (name) => (
                                                      <MenuItem
                                                        key={name}
                                                        value={name.id}
                                                      >
                                                        {name.group_name}
                                                      </MenuItem>
                                                    ),
                                                  )}
                                              </Select>
                                            </FormControl>
                                          </Grid>

                                          <Grid item xs={12} md={6}>
                                            <FormControl
                                              fullWidth
                                              style={{
                                                width: "100%",
                                              }}
                                            >
                                              <InputLabel id="demo-multiple-checkbox-label">
                                                VOIP Spam
                                              </InputLabel>
                                              <Select
                                                labelId="demo-multiple-checkbox-label"
                                                id="demo-simple-select"
                                                label="VOIP Spam"
                                                multiple
                                                helperText="Select the language."
                                                style={{ textAlign: "left" }}
                                                value={voip}
                                                onChange={(e) => {
                                                  setVoip(e.target.value);
                                                }}
                                                renderValue={(selected) =>
                                                  selected.join(", ")
                                                }
                                                required
                                              >
                                                {options.map((name) => (
                                                  <MenuItem
                                                    key={name}
                                                    value={name}
                                                  >
                                                    <Checkbox
                                                      checked={
                                                        voip.indexOf(name) > -1
                                                      }
                                                    />
                                                    <ListItemText
                                                      primary={name}
                                                    />
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                            </FormControl>
                                          </Grid>

                                          <Grid item xs={12} md={6}>
                                            <FormControl
                                              className="frm_date"
                                              fullWidth
                                              style={{
                                                width: "100%",
                                              }}
                                            >
                                              <InputLabel id="add-did-status-label">
                                                Status
                                              </InputLabel>
                                              <Select
                                                labelId="add-did-status-label"
                                                id="add-did-status-select"
                                                label="Status"
                                                helperText="Select the language."
                                                style={{ textAlign: "left" }}
                                                value={selectedValue}
                                                onChange={(e) => {
                                                  setSelectedValue(
                                                    e.target.value,
                                                  );
                                                }}
                                                required
                                              >
                                                <MenuItem value={"A"}>
                                                  Active
                                                </MenuItem>
                                                <MenuItem value={"D"}>
                                                  Deactive
                                                </MenuItem>
                                              </Select>
                                            </FormControl>
                                            {validation.selectedValue && (
                                              <p
                                                className="mb-0"
                                                style={{
                                                  color: "red",
                                                  textAlign: "left",
                                                }}
                                              >
                                                {validation.selectedValue}
                                              </p>
                                            )}
                                          </Grid>

                                          <Grid item xs={12} md={6}>
                                            <FormControl
                                              className="frm_date"
                                              fullWidth
                                              style={{
                                                width: "100%",
                                              }}
                                            >
                                              <InputLabel id="add-did-recording-label">
                                                Recording
                                              </InputLabel>
                                              <Select
                                                labelId="add-did-recording-label"
                                                id="add-did-recording-select"
                                                label="Recording"
                                                helperText="Select the language."
                                                style={{ textAlign: "left" }}
                                                value={recording}
                                                onChange={(e) => {
                                                  setRecording(e.target.value);
                                                }}
                                                required
                                              >
                                                <MenuItem value={true}>
                                                  Yes
                                                </MenuItem>
                                                <MenuItem value={false}>
                                                  No
                                                </MenuItem>
                                              </Select>
                                            </FormControl>
                                            {validation.recording && (
                                              <p
                                                className="mb-0"
                                                style={{
                                                  color: "red",
                                                  textAlign: "left",
                                                }}
                                              >
                                                {validation.recording}
                                              </p>
                                            )}
                                          </Grid>

                                          <Grid item xs={12} md={6}>
                                            <FormControl
                                              fullWidth
                                              style={{
                                                width: "100%",
                                              }}
                                              className={classes.formControl}
                                            >
                                              <InputLabel id="demo-simple-select-label">
                                                Carrier Name
                                              </InputLabel>

                                              <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Carrier Name"
                                                helperText="Select the language."
                                                style={{ textAlign: "left" }}
                                                value={carrierName}
                                                onChange={(e) => {
                                                  setCarrierName(
                                                    e.target.value,
                                                  );
                                                }}
                                                required
                                              >
                                                <MenuItem value={""}>
                                                  none
                                                </MenuItem>
                                                {state?.getAdminDidCarrier?.did_carrier?.map(
                                                  (item, index) => {
                                                    return (
                                                      <MenuItem
                                                        key={item.id}
                                                        value={
                                                          item?.carrier_name
                                                        }
                                                      >
                                                        {item.carrier_name}
                                                      </MenuItem>
                                                    );
                                                  },
                                                )}
                                              </Select>
                                            </FormControl>

                                            {/* <TextField
                                         className="frm_date"
                                          style={{
                                            width: "100%",
                                            
                                         
                                          }}
                                          type="text"
                                          label="Carrier Name"
                                          variant="outlined"
                                          name="carrier_name"
                                          value={carrierName}
                                          onChange={(e) => {
                                            setCarrierName(e.target.value);
                                          }}
                                        /> */}
                                            {validation.carrierName && (
                                              <p
                                                className="mb-0"
                                                style={{
                                                  color: "red",
                                                  textAlign: "left",
                                                }}
                                              >
                                                {validation.carrierName}
                                              </p>
                                            )}
                                          </Grid>

                                          <Grid item xs={12} md={6}>
                                            <TextField
                                              className="frm_date"
                                              style={{
                                                width: "100%",
                                              }}
                                              type="text"
                                              label="Description"
                                              variant="outlined"
                                              name="destinationDescription"
                                              value={destinationDescription}
                                              onChange={(e) => {
                                                setDestinationDescription(
                                                  e.target.value,
                                                );
                                              }}
                                            />
                                          </Grid>
                                        </Grid>
                                      </form>
                                    </form>
                                  </DialogContent>
                                  <DialogActions
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      paddingBottom: "20px",
                                    }}
                                  >
                                    <Button
                                      variant="contained"
                                      className="all_cancel_btn"
                                      color="primary"
                                      sx={{
                                        fontSize: "16px !impotant",
                                        background:
                                          "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                        marginTop: "20px",
                                        padding: "10px 20px !important",
                                        textTransform: "capitalize !important",
                                      }}
                                      onClick={handleClose}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      variant="contained"
                                      className="all_button_clr"
                                      color="primary"
                                      sx={{
                                        fontSize: "16px !impotant",
                                        background: "#092b5f",
                                        marginTop: "20px",
                                        padding: "10px 20px !important",
                                        textTransform: "capitalize !important",
                                      }}
                                      onClick={handleSubmit}
                                    >
                                      save
                                    </Button>
                                  </DialogActions>
                                </Dialog>

                                {/* -----   Add Campaigns Modal End   ----- */}
                              </div>
                            </div>
                          </div>
                          {/* mobile_view_start */}
                          <div className="d-xxl-none d-xl-none d-lg-none d-md-none d-sm-block d-block">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexWrap: "wrap",
                                justifyContent: "end",
                                position: "relative",
                                top: "0",
                              }}
                            >
                              {/* import */}
                              {user.user_role === "Reseller" ? (
                                <></>
                              ) : (
                                <>
                                  <Typography
                                    onClick={handleClick}
                                    target="_blank"
                                    className="hover-content"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <IconButton>
                                      <FileDownloadIcon />
                                    </IconButton>
                                  </Typography>

                                  <div
                                    className="n-ppost"
                                    style={{ paddingRight: "20px" }}
                                  >
                                    Sample
                                  </div>
                                  <img
                                    className="n-ppost-name"
                                    src="https://i.ibb.co/rMkhnrd/sample2.png"
                                    alt="Image"
                                  />

                                  <div>
                                    <IconButton
                                      className="all_button_clr"
                                      onClick={handleOpenImport}
                                    >
                                      Import <ImportExportIcon />
                                    </IconButton>
                                  </div>
                                </>
                              )}

                              {/* import-end */}

                              {/* ==Add-modal== */}

                              {user.user_role === "Reseller" ? (
                                <></>
                              ) : (
                                <>
                                  {" "}
                                  <div>
                                    <IconButton
                                      className="all_button_clr"
                                      onClick={handleOpen}
                                    >
                                      Add <AddOutlinedIcon />
                                    </IconButton>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                          {/* mobile_view_end */}

                          <div className="d-flex justify-content-between">
                            <div className="d-flex justify-content-between flex-wrap">
                              <div>
                                <FormControl>
                                  {/* <FormLabel id="demo-row-radio-buttons-group-label">Live Calls</FormLabel> */}
                                  <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={radioValue} // Bind the selected value to state
                                    onChange={(e) => {
                                      setRadioValue(e.target.value);
                                      setLoader(true);
                                    }} // Handle change event
                                  >
                                    <FormControlLabel
                                      value=""
                                      control={<Radio />}
                                      label={`All(${
                                        radioValue === "A" ||
                                        radioValue === "D" ||
                                        radioValue === "S"
                                          ? 0
                                          : rows.length
                                      })`}
                                    />
                                    <FormControlLabel
                                      value="A"
                                      control={<Radio />}
                                      label={`Active(${
                                        radioValue === "" ||
                                        radioValue === "D" ||
                                        radioValue === "S"
                                          ? 0
                                          : rows.length
                                      })`}
                                    />
                                    <FormControlLabel
                                      value="D"
                                      control={<Radio />}
                                      label={`Deactivated(${
                                        radioValue === "" ||
                                        radioValue === "A" ||
                                        radioValue === "S"
                                          ? 0
                                          : rows.length
                                      })`}
                                    />
                                    <FormControlLabel
                                      value={"S"}
                                      control={<Radio />}
                                      label={`Suspended(${
                                        radioValue === "" ||
                                        radioValue === "A" ||
                                        radioValue === "D"
                                          ? 0
                                          : rows.length
                                      })`}
                                    />
                                  </RadioGroup>
                                </FormControl>

                                <Button
                                  variant="contained"
                                  style={{
                                    fontSize: "15px",
                                    borderRadius: "5px",
                                    border: "none",
                                    color: "#fff",
                                    px: 4,
                                    background: selectedCallerData.length
                                      ? "red"
                                      : "orange",
                                    textTransform: "capitalize",
                                    height: "35px",
                                    width: "auto",
                                    minWidth: "90px",
                                    flexShrink: 0,
                                    display:
                                      selectedCallerData.length === 0
                                        ? "none"
                                        : "inline-flex",
                                    justifyContent: "space-evenly",
                                    alignItems: "center",
                                  }}
                                  className="all_button_clr"
                                  color="error"
                                  onClick={handleMessage}
                                  startIcon={getSuspendIcon()}
                                >
                                  {getToggleSuspendText()}
                                </Button>
                              </div>
                            </div>

                            <div>
                              <Box
                                sx={{
                                  width: "auto",
                                  display: { xs: "none", md: "block" },
                                  marginBottom: { xs: "10px", md: "0px" },
                                }}
                              >
                                <TextField
                                  size="small"
                                  fullWidth
                                  variant="outlined"
                                  placeholder="Search destination numbers..."
                                  value={searchDestination} // Controlled by internal state
                                  onChange={(e) =>
                                    setSearchDestination(e.target.value)
                                  } // Updates the state
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                      </InputAdornment>
                                    ),
                                    endAdornment: searchDestination && ( // Show clear button only when there's input
                                      <InputAdornment position="end">
                                        <IconButton
                                          edge="end"
                                          size="small"
                                          sx={{ mr: -1 }}
                                          onClick={() =>
                                            setSearchDestination("")
                                          } // Clears the input
                                        >
                                          <ClearIcon fontSize="small" />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                    sx: {
                                      fontSize: { xs: "0.875rem", sm: "1rem" },
                                      height: { xs: "36px", sm: "40px" },
                                    },
                                  }}
                                />
                              </Box>
                            </div>
                          </div>
                          <div>
                            <Box
                              sx={{
                                width: "auto",
                                display: { xs: "block", md: "none" },
                                marginBottom: { xs: "10px", md: "0px" },
                              }}
                            >
                              <TextField
                                size="small"
                                fullWidth
                                variant="outlined"
                                placeholder="Search destination numbers..."
                                value={searchDestination} // Controlled by internal state
                                onChange={(e) =>
                                  setSearchDestination(e.target.value)
                                } // Updates the state
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                  ),
                                  endAdornment: searchDestination && ( // Show clear button only when there's input
                                    <InputAdornment position="end">
                                      <IconButton
                                        edge="end"
                                        size="small"
                                        sx={{ mr: -1 }}
                                        onClick={() => setSearchDestination("")} // Clears the input
                                      >
                                        <ClearIcon fontSize="small" />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  sx: {
                                    fontSize: { xs: "0.875rem", sm: "1rem" },
                                    height: { xs: "36px", sm: "40px" },
                                  },
                                }}
                              />
                            </Box>
                          </div>

                          {/* Suspend Confirmation Modal Start  */}
                          <Dialog
                            open={alertMessage}
                            onClose={handleAlertClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            sx={{ textAlign: "center" }}
                          >
                            <DialogTitle
                              className="modal_heading"
                              id="alert-dialog-title"
                              sx={{ color: "#133325", fontWeight: "600" }}
                            >
                              {`${getToggleSuspendText()} Confirmation`}
                            </DialogTitle>

                            <DialogContent>
                              <DialogContentText
                                id="alert-dialog-description"
                                sx={{ paddingBottom: "0px !important" }}
                              >
                                {`Are you sure you want to ${getToggleSuspendText().toLowerCase()}?`}
                              </DialogContentText>
                            </DialogContent>

                            <DialogActions
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                paddingBottom: "20px",
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: "16px !important",
                                  background:
                                    "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                  marginTop: "20px",
                                  marginLeft: "0px !important",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                }}
                                className="all_button_clr"
                                color="info"
                                onClick={handleAlertClose}
                                autoFocus
                              >
                                Cancel
                              </Button>

                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: "16px !important",
                                  marginTop: "20px",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                  marginLeft: "0px !important",
                                  marginRight: "0px !important",
                                }}
                                className="all_button_clr"
                                color="error"
                                onClick={handleDelete}
                                startIcon={getSuspendIcon()} // Use the icon based on the suspend state
                              >
                                {getToggleSuspendText()}
                              </Button>
                            </DialogActions>
                          </Dialog>

                          {/* Suspend Confirmation Modal End  */}
                          {loader ? (
                            <>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  width: "90%",
                                  marginTop: "9rem !important",
                                }}
                              >
                                <CircularProgress />
                              </Box>
                            </>
                          ) : (
                            <>
                              <ThemeProvider theme={theme}>
                                <div style={{ height: "100%", width: "100%" }}>
                                  <StyledDataGrid
                                    rows={filteredRows}
                                    columns={columns}
                                    density="compact"
                                    checkboxSelection
                                    disableRowSelectionOnClick
                                    rowSelectionModel={selectedRows}
                                    onRowSelectionModelChange={
                                      handleSelectionChange
                                    }
                                    getRowClassName={(params) =>
                                      isRowBordered(params)
                                        ? "borderedGreen"
                                        : "borderedRed"
                                    }
                                    components={{ Toolbar: GridToolbar }}
                                    slots={{
                                      toolbar: CustomToolbar,
                                    }}
                                    autoHeight
                                    sx={{
                                      "& .MuiDataGrid-toolbarContainer": {
                                        gap: "1px", // Spacing between buttons
                                      },
                                      "& .MuiButton-root": {
                                        // Targets all buttons (filter, export, density)
                                        fontSize: "calc(0.6rem + 0.4vw)", // Button text size
                                        minWidth: "unset", // Remove minimum width constraint
                                      },
                                      "& .MuiSvgIcon-root": {
                                        // Icons inside buttons
                                        fontSize: "calc(0.6rem + 0.4vw)", // Adjust icon size
                                      },
                                    }}
                                  />
                                </div>
                              </ThemeProvider>
                            </>
                          )}
                          {/* </>
                      )} */}

                          {/* -----   Edit Campaign Modal Start   ----- */}

                          <Dialog
                            className="custom_dailog_box_user"
                            open={edit}
                            sx={{ textAlign: "center" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                paddingTop: "10px",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography
                                className="modal_heading"
                                sx={{
                                  color: "#133325",
                                  fontWeight: "600",
                                  width: "500px",
                                }}
                              >
                                Update Destination
                              </Typography>
                              <IconButton
                                className="close_icon"
                                onClick={handleEditClose}
                                sx={{ float: "inline-end" }}
                              >
                                <Close />
                              </IconButton>
                            </Box>
                            <DialogContent>
                              <form
                                style={{
                                  textAlign: "center",
                                  // overflow: "auto",

                                  padding: "10px",
                                }}
                              >
                                <Grid container spacing={1}>
                                  <Grid item xs={12} md={6}>
                                    <TextField
                                      style={{
                                        width: "100%",
                                      }}
                                      type="number"
                                      label="DID Number"
                                      variant="outlined"
                                      name="tfnNumber"
                                      value={parseInt(tfnNumber)}
                                      onChange={handleChange}
                                      padding={"0px 0 !important"}
                                    />
                                    {validation.tfnNumber && (
                                      <p
                                        className="mb-0"
                                        style={{
                                          color: "red",
                                          textAlign: "left",
                                        }}
                                      >
                                        {validation.tfnNumber}
                                      </p>
                                    )}
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                      <InputLabel id="demo-simple-select-label">
                                        Reseller
                                      </InputLabel>

                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Reseller"
                                        helperText="Select the language."
                                        style={{ textAlign: "left" }}
                                        value={resellerId}
                                        onChange={(e) => {
                                          setResellerId(e.target.value);
                                        }}
                                        required
                                      >
                                        <MenuItem value="">none</MenuItem>
                                        {resellers?.map((item, index) => {
                                          return (
                                            <MenuItem
                                              key={index}
                                              value={item?.reseller_id}
                                            >
                                              {item.username}
                                            </MenuItem>
                                          );
                                        })}
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} md={12}>
                                    {resellerId === "" ? (
                                      <>
                                        <FormControl
                                          fullWidth
                                          style={{
                                            width: "100%",
                                            margin: "7px 0",
                                          }}
                                        >
                                          <InputLabel id="demo-simple-select-label">
                                            UserName
                                          </InputLabel>

                                          <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="UserName"
                                            helperText="Select the language."
                                            style={{ textAlign: "left" }}
                                            value={userId}
                                            onChange={(e) => {
                                              setUserId(e.target.value);
                                            }}
                                          >
                                            <MenuItem value={""}>none</MenuItem>
                                            {users?.map((item, index) => {
                                              return (
                                                <MenuItem
                                                  key={index}
                                                  value={item?.user_id}
                                                >
                                                  {item.username}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        </FormControl>
                                        {validation.userId && (
                                          <p
                                            className="mb-0"
                                            style={{
                                              color: "red",
                                              textAlign: "left",
                                            }}
                                          >
                                            {validation.userId}
                                          </p>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <FormControl
                                          fullWidth
                                          style={{
                                            width: "100%",
                                            margin: "7px 0",
                                          }}
                                        >
                                          <InputLabel id="demo-simple-select-label">
                                            UserName
                                          </InputLabel>

                                          <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="UserName"
                                            helperText="Select the language."
                                            style={{ textAlign: "left" }}
                                            value={userId}
                                            onChange={(e) => {
                                              setUserId(e.target.value);
                                            }}
                                          >
                                            <MenuItem value={""}>none</MenuItem>
                                            {resellerUsers?.map(
                                              (item, index) => {
                                                return (
                                                  <MenuItem
                                                    key={index}
                                                    value={item?.user_id}
                                                  >
                                                    {item.username}
                                                  </MenuItem>
                                                );
                                              },
                                            )}
                                          </Select>
                                        </FormControl>
                                        {validation.userId && (
                                          <p
                                            className="mb-0"
                                            style={{
                                              color: "red",
                                              textAlign: "left",
                                            }}
                                          >
                                            {validation.userId}
                                          </p>
                                        )}
                                      </>
                                    )}
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      <DatePicker
                                        label="Expiry Date"
                                        value={fromDate}
                                        onChange={handleFromDateChange}
                                        format="DD/MM/YYYY"
                                        closeOnSelect={true}
                                        slotProps={{
                                          /* POPUP HEIGHT CONTROL */
                                          desktopPaper: {
                                            sx: {
                                              height: "320px",
                                              maxHeight: "320px",
                                              overflow: "hidden",
                                            },
                                          },

                                          /* CALENDAR INNER HEIGHT */
                                          layout: {
                                            sx: {
                                              height: "300px",
                                              ".MuiPickersLayout-contentWrapper":
                                                {
                                                  height: "280px",
                                                },
                                            },
                                          },

                                          /* ACTION BUTTONS */
                                          actionBar: {
                                            actions: [
                                              "clear",
                                              "cancel",
                                              "accept",
                                            ],
                                            sx: {
                                              px: 1,
                                              pb: 1,
                                              pt: 0,
                                              justifyContent: "flex-end",
                                              gap: "8px",
                                            },
                                          },

                                          /* INPUT FIELD */
                                          textField: {
                                            fullWidth: true,
                                            // className: "frm_date",
                                            InputProps: {
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  {/* icon */}
                                                </InputAdornment>
                                              ),
                                            },
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                    <InputLabel
                                      style={{
                                        textAlign: "left",
                                        fontSize: "11px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <b>Note:</b> &nbsp; A daily reset at 11:00
                                      AM{" "}
                                    </InputLabel>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <FormControl
                                              fullWidth
                                              style={{
                                                width: "100%",
                                              }}
                                            >
                                              <InputLabel id="demo-multiple-checkbox-label">
                                                VOIP Spam
                                              </InputLabel>
                                              <Select
                                                labelId="demo-multiple-checkbox-label"
                                                id="demo-simple-select"
                                                label="VOIP Spam"
                                                multiple
                                                helperText="Select the language."
                                                style={{ textAlign: "left" }}
                                                value={voip}
                                                onChange={(e) => {
                                                  setVoip(e.target.value);
                                                }}
                                                renderValue={(selected) =>
                                                  selected.join(", ")
                                                }
                                                required
                                              >
                                                {options.map((name) => (
                                                  <MenuItem
                                                    key={name}
                                                    value={name}
                                                  >
                                                    <Checkbox
                                                      checked={
                                                        voip.indexOf(name) > -1
                                                      }
                                                    />
                                                    <ListItemText
                                                      primary={name}
                                                    />
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                            </FormControl>
                                  </Grid>

                                  <Grid item xs={12} md={6}>
                                    <FormControl
                                      className="frm_date"
                                      fullWidth
                                      style={{ width: "100%" }}
                                    >
                                      <InputLabel id="demo-simple-select-label">
                                        IVR Authentication
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="IVR Authentication"
                                        helperText="Select the language."
                                        style={{ textAlign: "left" }}
                                        value={ivrAuthentication}
                                        onChange={(e) => {
                                          setIvrAuthentication(e.target.value);
                                        }}
                                        required
                                      >
                                        {ivrOptions.map((item) => (
                                          <MenuItem key={item} value={item}>
                                            {item.toString()}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  <Grid item xs={12} md={6}>
                                    <FormControl
                                      className="frm_date"
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      <InputLabel id="demo-multiple-checkbox-label">
                                        Campaign Name
                                      </InputLabel>
                                      <Select
                                        style={{ textAlign: "left" }}
                                        labelId="demo-multiple-checkbox-label"
                                        label="Campaign Name"
                                        id="demo-multiple-checkbox"
                                        fullWidth
                                        value={redirectGroup}
                                        onChange={(e) =>
                                          setRedirectGroup(e.target.value)
                                        }
                                        input={
                                          <OutlinedInput label="Campaign Name" />
                                        }
                                        MenuProps={MenuProps}
                                      >
                                        {redirectGroupData &&
                                          redirectGroupData?.map((name) => (
                                            <MenuItem
                                              key={name}
                                              value={name.id}
                                            >
                                              {name.group_name}
                                            </MenuItem>
                                          ))}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <FormControl
                                      className="frm_date"
                                      fullWidth
                                      style={{ width: "100%" }}
                                    >
                                      <InputLabel id="edit-did-recording-label">
                                        Recording
                                      </InputLabel>
                                      <Select
                                        labelId="edit-did-recording-label"
                                        id="edit-did-recording-select"
                                        label="Recording"
                                        helperText="Select the language."
                                        style={{ textAlign: "left" }}
                                        value={recording}
                                        onChange={(e) => {
                                          setRecording(e.target.value);
                                        }}
                                        required
                                      >
                                        <MenuItem value={true}>Yes</MenuItem>
                                        <MenuItem value={false}>No</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <FormControl
                                      className="frm_date"
                                      fullWidth
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      <InputLabel id="edit-did-status-label">
                                        Status
                                      </InputLabel>
                                      <Select
                                        labelId="edit-did-status-label"
                                        id="edit-did-status-select"
                                        label="Status"
                                        helperText="Select the language."
                                        style={{ textAlign: "left" }}
                                        value={selectedValue}
                                        onChange={handleSelectChange}
                                        required
                                      >
                                        <MenuItem value={"A"}>Active</MenuItem>
                                        <MenuItem value={"D"}>
                                          Deactive
                                        </MenuItem>
                                        <MenuItem value={"S"}>
                                          Suspended
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <FormControl
                                      fullWidth
                                      style={{
                                        width: "100%",
                                      }}
                                      className={classes.formControl}
                                    >
                                      <InputLabel id="edit-did-carrier-label">
                                        Carrier Name
                                      </InputLabel>

                                      <Select
                                        labelId="edit-did-carrier-label"
                                        id="edit-did-carrier-select"
                                        label="Carrier Name"
                                        helperText="Select the language."
                                        style={{ textAlign: "left" }}
                                        value={carrierName}
                                        onChange={(e) => {
                                          setCarrierName(e.target.value);
                                        }}
                                        required
                                      >
                                        <MenuItem value={""}>none</MenuItem>
                                        {state?.getAdminDidCarrier?.did_carrier?.map(
                                          (item, index) => {
                                            return (
                                              <MenuItem
                                                key={item.id}
                                                value={item?.carrier_name}
                                              >
                                                {item.carrier_name}
                                              </MenuItem>
                                            );
                                          },
                                        )}
                                      </Select>
                                    </FormControl>
                                    {/* <TextField
                                      className="frm_date"
                                    style={{
                                      width: "100%",
                                      
                                    }}
                                    type="text"
                                    label="Carrier Name"
                                    variant="outlined"
                                    name="carrier_name"
                                    value={carrierName}
                                    onChange={(e) => {
                                      setCarrierName(e.target.value);
                                    }}
                                    required
                                  /> */}
                                    {validation.carrierName && (
                                      <p
                                        className="mb-0"
                                        style={{
                                          color: "red",
                                          textAlign: "left",
                                        }}
                                      >
                                        {validation.carrierName}
                                      </p>
                                    )}
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <TextField
                                      className="frm_date"
                                      style={{ width: "100%" }}
                                      type="text"
                                      label="Description"
                                      variant="outlined"
                                      name="destinationDescription"
                                      value={destinationDescription}
                                      onChange={(e) => {
                                        setDestinationDescription(
                                          e.target.value,
                                        );
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              </form>
                            </DialogContent>
                            <DialogActions
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                paddingBottom: "20px",
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: "16px !impotant",
                                  background:
                                    "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                  marginTop: "0px",
                                  marginLeft: "0px !important",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                }}
                                className="all_button_clr"
                                color="info"
                                onClick={handleEditClose}
                                autoFocus
                              >
                                Cancel
                              </Button>
                              <Button
                                className="all_button_clr"
                                sx={{
                                  fontSize: "16px !impotant",
                                  marginTop: "0px",
                                  marginLeft: "0px !important",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                }}
                                variant="contained"
                                color="primary"
                                onClick={handleUpdate}
                              >
                                Update
                              </Button>
                            </DialogActions>
                          </Dialog>

                          {/* -----   Edit Campaign Modal End   ----- */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
}

export default DID_TFN_number;
